import type { GpcAnalysis } from '@/types';
import { api } from './api';

const gpcApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getGpc: builder.query<GpcAnalysis, number>({
      query: (id) => `inventories/${id}/gpc`,
    }),
    exportGpc: builder.mutation<{ url: string }, { inventoryId: number }>({
      query: ({ inventoryId }) => ({
        url: `inventories/${inventoryId}/gpc/export`,
        method: 'POST',
      }),
    }),
  }),
});

export const { useGetGpcQuery, useExportGpcMutation } = gpcApi;
